export const getMaxPrizeFromGame = (jogo, megaBola = false) => {
  if (!jogo.lstTamanhoFixo || jogo.lstTamanhoFixo.length <= 0) {
    if (!jogo.objTipoJogo) {
      return undefined;
    }

    return jogo.objTipoJogo.numValorPagoJogo;
  }

  if (
    !jogo.lstTamanhoFixo[0].lstPagoQtdAcertos ||
    jogo.lstTamanhoFixo[0].lstPagoQtdAcertos.length <= 0
  ) {
    return jogo.lstTamanhoFixo.reduce(
      (max, item) =>
        item.numValorPagoTamanhoFixo > max ? item.numValorPagoTamanhoFixo : max,
      0
    );
  }

  const fromInside = jogo.lstTamanhoFixo.reduce((max, item) => {
    const value = item.lstPagoQtdAcertos.reduce((maxAcert, other) => {
      const value = megaBola ? other.numValorPagoMegaBola : other.numValorPago;
      return value > maxAcert ? value : maxAcert;
    }, 0);
    return value > max ? value : max;
  }, 0);

  return fromInside;
};



// WEBPACK FOOTER //
// ./src/utils/getMaxPrize.js